import withFormikSelect from '../withSelectFormik';
import withOptionsSelectValueInitById from '../withOptionsSelectValueInitById';
import options from './options';
import withInputErrorMessage from '../../withInputErrorMessage';

export default withFormikSelect(withInputErrorMessage(withOptionsSelectValueInitById(options)));
